import { render } from "./apply1.vue?vue&type=template&id=256d824b&scoped=true"
import script from "./apply1.vue?vue&type=script&lang=js"
export * from "./apply1.vue?vue&type=script&lang=js"

import "./apply1.vue?vue&type=style&index=0&id=256d824b&lang=less&scoped=true"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-256d824b"]])

export default __exports__